import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
    level = '1',
    auditResult = '1', // 0 审核不通过
    auditSummary = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpiAudit.flowAudited, {
        projId,
        level: Number.parseInt(level),
        auditResult: Number.parseInt(auditResult),
        auditSummary,
    }, options);
    if (error) return { error, status };
    return content || { };
};
